document.addEventListener('DOMContentLoaded', () => {
    const listItems = document.querySelectorAll('.location-list .location-label, .label-with-iframe-container .location-label');
    const accordionItems = document.querySelectorAll('.label-with-iframe-container .location-label');
    const iframeWrappers = document.querySelectorAll('.list-iframe-wrapper .label-with-iframe-container');

    listItems.forEach((listItem) => {
        listItem.addEventListener('click', (event) => {
            const handle = event.target.dataset.handle;
            if (handle) {
                iframeWrappers.forEach((iframeWrapper) => {
                    iframeWrapper.classList.remove('active');
                });
                const iframe = document.querySelector(`.${handle}`);
                if (iframe) {
                    iframe.classList.add('active');
                }
                listItems.forEach((item) => {
                    item.classList.remove('active');
                });
                accordionItems.forEach((item) => {
                    item.classList.remove('active');
                });

                const handleElements = document.querySelectorAll(`[data-handle="${handle}"]`);
                if (handleElements) {
                    handleElements.forEach((item) => {
                        item.classList.add('active');
                    });
                }
            }
        });
    });
});